import { SITE_ORIGIN } from './site';

/** Organization + WebSite JSON-LD for the marketing homepage (`/`). */
export function buildHomeJsonLd(): unknown[] {
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'QInvesting',
      url: SITE_ORIGIN,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'QInvesting',
      url: SITE_ORIGIN,
    },
  ];
}
